import React from 'react';
import styles from './footer.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
      Legal | Support | Social Media
    </footer>
  );
}

export default Footer;
